import { Routes } from '@angular/router';

import { roleGuard } from '../../core/guards/role.guard';
import { RoleCode } from '../../shared/models/user/user.enums';

export const jonasExportFilesRoutes: Routes = [
	{
		path: 'jonas-export-files',
		canMatch: [roleGuard],
		data: { allowedRoles: [RoleCode.SUPER_ADMIN] },
		children: [
			{
				path: '',
				loadComponent: () =>
					import('./pages/jonas-export-files-page/jonas-export-files-page.component').then(c => c.JonasExportFilesPageComponent)
			}
		]
	}
];
